import { combineEpics } from "redux-observable";
import { carrierPropertiesEpic } from "./carrierPropertiesEpic";
import { codeValEpic } from "./codeValEpic";
import { userStationsEpic } from "./userStationsEpic";
import { HelpLinkEpic } from "./HelpLinkEpic";

export const commonEpic = combineEpics(carrierPropertiesEpic, codeValEpic, userStationsEpic, HelpLinkEpic);
